module.exports = __webpack_public_path__ + "media/coffee-preferences/sub_flavor_sweet_honey-0b21869c.png";